import { render, staticRenderFns } from "./fileViewer.vue?vue&type=template&id=b89c7c70&scoped=true&"
import script from "./fileViewer.vue?vue&type=script&lang=js&"
export * from "./fileViewer.vue?vue&type=script&lang=js&"
import style0 from "./fileViewer.vue?vue&type=style&index=0&id=b89c7c70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89c7c70",
  null
  
)

export default component.exports